if (!Number.prototype.round) {
    Number.prototype.round = function (decimals) {
        decimals = decimals || 0
        return Number(Math.round(this + 'e' + decimals) + 'e-' + decimals)
    }
}

if (!Number.prototype.formatCurrency) {
    Number.prototype.formatCurrency = function (rounding) {
        rounding = rounding == null ? 2 : rounding
        return this.toFixed(rounding).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
}

if (!Number.prototype.zeroPad) {
    Number.prototype.zeroPad = function (width) {
        var str = this + ''
        return str.length >= width ? str : new Array(width - str.length + 1).join('0') + str
    }
}

if (!Number.prototype.getLength) {
    Number.prototype.getLength = function () {
        return this.toString().length
    }
}

if (!Number.prototype.abbreviate) {
    const suffixes = ['', 'k', 'M', 'B', 'T', 'Q', 'P', 'S']
    Number.prototype.abbreviate = function (significantDigits) {
        significantDigits = significantDigits === undefined ? 3 : significantDigits
        var scientificParts = this.toExponential(significantDigits - 1).split('e+') // exponent of ten
        var digits = scientificParts[0]
        var exponent = scientificParts[1]
        var suffixIndex = Math.floor(exponent / 3)
        var suffix = suffixes[suffixIndex]
        var moveDecimalRight = exponent % 3
        var value = digits * Math.pow(10, moveDecimalRight)

        // The round here alleviates certain numbers ending up with miniscule decimals eg: (13.600000000000000001)
        return `${value.round(3)}${suffix}`
    }
}
